import { Badge } from "react-bootstrap";
import { CAND_STATUS_META, CandStatus } from "./candidateStatus";

export const StatusBadge: React.FC<{ status: CandStatus }> = ({ status }) => {
  const m = CAND_STATUS_META[status];
  // Match the sibling markers in the same Status cell (tags, the premium-enrich
  // and degraded-source marks), which are all fontSize 10 - the default
  // Bootstrap badge size left this pill visibly larger than its neighbours.
  return (
    <Badge bg={m.bg} text={m.text} style={{ fontSize: 10 }}>
      {m.label}
    </Badge>
  );
};
